<template>
    <div id="widgets-edit" style="width: 100%">
        <!-- Area for first section of the homepage -->
        <div class="columns is-desktop top" style="width: 100%">
            <div id="announcements" class="column is-one-quarter-desktop is-full">
                <h2>Announcements</h2>
                <b-button class="is-primary" type="button"
                          uk-toggle="target: #add-announcement-modal"
                          size="is-small">
                    Add/Edit Announcements
                </b-button>
                <br><br>
                <div class="announcement-widget-container">

                    <div class="announcement-container" v-for="(a, index) in announcements"
                         v-if="announcements.length > 0">
                        <b-message :title="a.title" has-icon
                                   :closable="false"
                                   :type="`is-${a.announcementType}`">
                            {{a.message}}
                        </b-message>
                    </div>

                </div>
            </div>
            <div class="column is-three-quarters-desktop is-full" style="opacity: 0.6" id="internal">
                <h2>WageUp Dashboard Tools</h2>
                <div class="columns internal-widget-container">
                    <div class="card widget column is-one-quarter-desktop is-one-third-tablet is-full-mobile">
<!--                        <div class="card-icon">-->
<!--                            -->
<!--                        </div>-->
                        <div class="card-content">
                            <div class="card-title">
                            <img src="../../assets/images/logo/Icon-Blue-01.png" alt="Placeholder image" class="image-icon">
                            <p class="title">
                                My Dashboard
                            </p>
                                </div>
                            <div class="content">
                                <font-awesome-icon icon="chart-line" type="is-primary"></font-awesome-icon>
                                Click this widget to go to My Dashboard
                                <br>
                            </div>
                        </div>

                    </div>
                    <div class="card widget column is-one-quarter-desktop is-one-third-tablet is-full-mobile">
<!--                        <div class="card-icon">-->
<!--                            -->
<!--                        </div>-->
                        <div class="card-content">
                            <div class="card-title">
                            <img src="../../assets/images/logo/Icon-Blue-01.png" alt="Placeholder image" class="image-icon">
                            <p class="title">
                                Communications
                            </p>
                                </div>
                            <div class="content">
                                <font-awesome-icon icon="chart-line" type="is-primary"></font-awesome-icon>
                                Click this widget to go to Program Communications
                                <br>
                            </div>
                        </div>

                    </div>
                    <div class="card widget column is-one-quarter-desktop is-one-third-tablet is-full-mobile">
<!--                        <div class="card-icon">-->
<!--                            -->
<!--                        </div>-->
                        <div class="card-content">
                            <div class="card-title">
                            <img src="../../assets/images/logo/Icon-Blue-01.png" alt="Placeholder image" class="image-icon">
                            <p class="title">
                                Scheduler
                            </p>
                                </div>
                            <div class="content">
                                <font-awesome-icon icon="calendar" type="is-primary"></font-awesome-icon>
                                Click this widget to go to Scheduler
                                <br>
                            </div>
                        </div>

                    </div>

                    <div class="card widget column is-one-third-desktop is-one-third-tablet is-full-mobile">
<!--                        <div class="card-icon">-->
<!--                            -->
<!--                        </div>-->
                        <div class="card-content">
                            <div class="card-title">
                            <img src="../../assets/images/logo/Icon-Blue-01.png" alt="Placeholder image" class="image-icon">
                            <p class="title">
                                Surveys
                            </p>
                                </div>
                            <div class="content">
                                <font-awesome-icon icon="users" type="is-primary"></font-awesome-icon>
                                Click this widget to go to Surveys
                                <br>
                            </div>
                        </div>

                    </div>
                    <div class="card widget column is-one-third-desktop is-one-third-tablet is-full-mobile">
<!--                        <div class="card-icon">-->
<!--                            -->
<!--                        </div>-->
                        <div class="card-content">
                            <div class="card-title">
                            <img src="../../assets/images/logo/Icon-Blue-01.png" alt="Placeholder image" class="image-icon">
                            <p class="title">
                                Maps
                            </p>
                                </div>
                            <div class="content">
                                <font-awesome-icon icon="map" type="is-primary"></font-awesome-icon>
                                Click this widget to go to Maps
                                <br>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
<!--            <div class="column is-one-quarter-desktop is-full" style="opacity: 0.6" id="history">-->
<!--                <h2>History</h2>-->
<!--                <div class="columns ">-->
<!--                    <div class="column history-widget-container">-->
<!--                        <ul class="uk-list uk-list-divider">-->
<!--                            <li v-for="(h, index) in history" :key="index">-->
<!--                                <p>{{ h.display }}<br><i style="font-size: 12px" class="is-small">{{ h.date | dateFormat }}</i></p>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->
        </div>
        <div id="external">
            <h2>Service Provider Communications & Tools</h2>
            <draggable v-if="external.length && hasPermissionToEdit" v-model="external" group="metrics" @start="drag=true" @end="drag=false"
                       class="external-widget-container columns">
                <div class="card widget column is-one-third-tablet is-full-mobile homepage-card" v-for="(e, index) in external" :key="e.id"
                     :class="externalClass(e.grid_size)">
                    <div class="card-image">
                        <figure class="image" v-if="e.image">
                            <img :src="e.image" :alt="e.message" class="external-image">
                        </figure>
                    </div>
                    <div class="card-content">
                        <p class="title">
                            {{e.title}}
                        </p>
                        <div class="content">

                            {{e.message}}
                            <br>

                        </div>
                        <time datetime="2016-1-1">{{e.time}}</time>
                    </div>
                    <footer class="card-footer" v-if="hasPermissionToEdit">
                        <a uk-toggle="target: #add-widget-modal" @click="editWidgetToggle(e.id, index)"
                           class="card-footer-item">Edit</a>
                        <a @click="deleteWidgetConfirm(e.id, index)" class="card-footer-item">Delete</a>
                    </footer>
                </div>
                <div v-if="hasPermissionToEdit" class="add-widget uk-card uk-card-default column is-one-fifth is-one-third-tablet is-full-mobile">
                    <b-button class="is-primary add-new-widget-button" type="button" @click="clearAddWidget"
                              uk-toggle="target: #add-widget-modal"
                              pack="fas"
                              icon-right="plus">
                        Add New Widget
                    </b-button>

                </div>
            </draggable>
            <div v-if="!hasPermissionToEdit" class="external-widget-container columns">
                <div class="card widget column is-one-third-tablet is-full-mobile homepage-card" v-for="(e, index) in external" :key="e.id"
                     :class="externalClass(e.grid_size)">
                    <div class="card-image">
                        <figure class="image" v-if="e.image">
                            <img :src="e.image" :alt="e.message" class="external-image">
                        </figure>
                    </div>
                    <div class="card-content">
                        <p class="title">
                            {{e.title}}
                        </p>
                        <div class="content">

                            {{e.message}}
                            <br>

                        </div>
                        <time datetime="2016-1-1">{{e.time}}</time>
                    </div>
                    <footer class="card-footer" v-if="hasPermissionToEdit">
                        <a uk-toggle="target: #add-widget-modal" @click="editWidgetToggle(e.id, index)"
                           class="card-footer-item">Edit</a>
                        <a @click="deleteWidgetConfirm(e.id, index)" class="card-footer-item">Delete</a>
                    </footer>
                </div>
                <div v-if="hasPermissionToEdit" class="add-widget uk-card uk-card-default column is-one-fifth is-one-third-tablet is-full-mobile">
                    <b-button class="is-primary add-new-widget-button" type="button" @click="clearAddWidget"
                              uk-toggle="target: #add-widget-modal"
                              pack="fas"
                              icon-right="plus">
                        Add New Widget
                    </b-button>

                </div>
            </div>

            <div id="add-announcement-modal" uk-modal>
                <div class="uk-modal-dialog uk-modal-body">
                    <div class="announcement-list uk-text-center" v-if="showAnnouncementList">
                        <button class="uk-button uk-button-primary"
                                @click="showAnnouncementList = false" v-if="!rearrangingAnnouncements">Add New Announcement</button>
                        <button class="uk-button uk-button-secondary" v-if="!rearrangingAnnouncements" @click="rearrangingAnnouncements = true">Re-arrange Announcements</button>
                        <button @click="saveAnnouncementOrder" v-if="rearrangingAnnouncements" class="uk-button uk-button-secondary">Save</button>
                        <button @click="rearrangingAnnouncements = false" v-if="rearrangingAnnouncements" class="uk-button">Cancel</button>
                        <br><br>
                        <draggable v-if="rearrangingAnnouncements" v-model="newOrderAnnouncements">
                            <div class="reorder-announcement" :class="'border-' + a.announcementType" v-for="a in newOrderAnnouncements" :key="a.id">{{ a.title }}</div>
                        </draggable>
                        <ul v-else uk-accordion class="uk-text-left">

                            <li v-for="(a, index) in announcements" class="draggable-item" :key="a.id" :class="'border-' + a.announcementType">
                                <a class="uk-accordion-title" href="#">{{ a.title }}</a>
                                <div class="uk-accordion-content">
                                    <div class="announcement-edit" v-if="editAnnouncement == a.id">
                                        <b-field label="Title"
                                                 :type="validator(changeA.title, 'text', 'announcement')"
                                        >
                                            <b-input v-model="changeA.title"></b-input>
                                        </b-field>
                                        <b-field label="Message"
                                                 :type="validator(changeA.message, 'text', 'announcement')"
                                        >
                                            <b-input type="textarea" v-model="changeA.message"></b-input>
                                        </b-field>
                                        <b-field>
                                            <b-radio-button :native-value="true" v-model="isAnnouncementLink">External Link</b-radio-button>
                                            <b-radio-button :native-value="false" v-model="isAnnouncementLink">File</b-radio-button>
                                        </b-field>
                                        <b-field label="Link" v-if="isAnnouncementLink"
                                                 :type="validator(changeA.url_link, 'link', 'announcement')"
                                        >
                                            <b-input v-model="changeA.url_link"></b-input>
                                        </b-field>
                                        <b-field v-else>
                                            <b-upload
                                                v-model="changeA.file"
                                                drag-drop>
                                                <section class="section">
                                                    <div class="content has-text-centered">
                                                        <p><b-icon icon="upload" size="is-large"></b-icon></p>
                                                    </div>
                                                </section>
                                            </b-upload>

                                        </b-field>
                                        <div class="tags">
                                            <span class="tag" :class="validator(changeA.file, 'file', 'external')" v-if="changeA.file">
                                                {{ changeA.file.name }}
                                                <button class="delete is-small" @click="changeA.file = null"></button>
                                            </span>
                                        </div>
                                        <b-field grouped>
                                            <b-field label="Start/From">
                                                <b-datepicker v-model="changeA.start_date"
                                                              placeholder="Start of announcement"
                                                              trap-focus
                                                ></b-datepicker>
                                            </b-field>
                                            <b-field label="End/To">
                                                <b-datepicker v-model="changeA.end_date"
                                                              placeholder="End of announcement"
                                                              trap-focus
                                                ></b-datepicker>
                                            </b-field>
                                        </b-field>
                                        <b>Type</b>
                                        <b-field>
                                            <b-radio v-for="(t, index) in announcementTypeList"
                                                     :key="index"
                                                     :native-value="t.value"
                                                     :type="'is-' + t.value"
                                                     v-model="changeA.announcementType"
                                                     :style="{color: t.color}"
                                            >{{ t.text }}</b-radio>
                                        </b-field>
                                        <b>Choose Permissions</b>
                                        <b-field grouped group-multiline>
                                            <b-field><b-checkbox @input="toggleAllPermissions" class="checkbox-perm" v-model="hasAllPermissions">All</b-checkbox></b-field>
                                            <b-field v-for="(g, index) in groups" :key="index">
                                                <b-checkbox v-model="permissions"
                                                        :native-value="g.id"
                                                        >{{ g.group_name }}</b-checkbox>
                                            </b-field>
                                        </b-field>
                                    </div>
                                    <div class="announcement-info" v-else>
                                        <p>{{ a.message }}</p>
                                        <p v-if="a.url_link">Link to: <a :href="a.url_link" target="_blank">{{ a.url_link }}</a></p>
                                        <p v-if="a.start_date && a.end_date"><b>From: </b>{{ a.start_date }} <b>To: </b>{{ a.end_date }}</p>
                                    </div>
                                    <br><br>
                                    <div class="announcement-buttons">
                                        <button class="uk-button uk-button-primary"
                                                v-if="editAnnouncement != a.id"
                                                @click="editAnnouncementSetup(a)">
                                            Edit
                                        </button>
                                        <button class="uk-button uk-button-primary"
                                                @click="submitAnnouncementEdit(index)"
                                                :disabled="(changeA.title === null || changeA.title === '') &&
                                                (changeA.message === null || changeA.message === '') && !announcementValidator"
                                                v-if="editAnnouncement === a.id">Update</button>
                                        <button class="uk-button"
                                                @click="cancelEditAnnouncement()"
                                                v-if="editAnnouncement === a.id"
                                        >Cancel</button>
                                        <button class="uk-button uk-button-danger"
                                                @click="deleteAnnouncementConfirm(a.id, a.id, index)">Remove</button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="add-new-announcement" v-if="!showAnnouncementList">
                        <a @click="showAnnouncementList = true"><font-awesome-icon icon="arrow-left"></font-awesome-icon> Back</a>
                        <b-field label="Title"
                                 :type="validator(announcementContent.title, 'text', 'announcement')"
                        >
                            <b-input v-model="announcementContent.title"></b-input>
                        </b-field>
                        <b-field
                            :type="validator(announcementContent.message, 'text', 'announcement')"
                            label="Message">
                            <b-input v-model="announcementContent.message"></b-input>
                        </b-field>
                        <b-field>
                            <b-radio-button :native-value="true" v-model="isAnnouncementLink">External Link</b-radio-button>
                            <b-radio-button :native-value="false" v-model="isAnnouncementLink">File</b-radio-button>
                        </b-field>
                        <b-field label="External Link"
                                 :type="validator(announcementContent.url_link, 'link', 'announcement')"
                                 v-if="isAnnouncementLink">
                            <b-input v-model="announcementContent.url_link"></b-input>
                        </b-field>
                        <b-field v-else
                                 :type="validator(announcementContent.file, 'file', 'announcement')"
                        >
                            <b-upload
                                v-model="announcementContent.file"
                                drag-drop>
                                <section class="section">
                                    <div class="content has-text-centered">
                                        <p><b-icon icon="upload" size="is-large"></b-icon></p>
                                        <p>Upload File Here</p>
                                    </div>
                                </section>
                            </b-upload>

                        </b-field>
                        <div class="tags">
                            <span class="tag" :class="validator(announcementContent.file, 'file', 'external')" v-if="announcementContent.file">
                                {{ announcementContent.file.name }}
                                <button class="delete is-small" @click="announcementContent.file = null"></button>
                            </span>
                        </div>

                        <b-field grouped>
                            <b-field label="Start/From">
                                <b-datepicker v-model="announcementContent.start_date"
                                              placeholder="Start of announcement"
                                              trap-focus
                                ></b-datepicker>
                            </b-field>
                            <b-field label="End/To">
                                <b-datepicker v-model="announcementContent.end_date"
                                              placeholder="End of announcement"
                                              trap-focus
                                ></b-datepicker>
                            </b-field>
                        </b-field>
                        <h3>Choose your announcement type:</h3>
                        <b-field>
                            <b-radio v-for="(t, index) in announcementTypeList"
                                     :key="index"
                                     :native-value="t.value"
                                     :type="'is-' + t.value"
                                     v-model="announcementContent.type"
                                     :style="{color: t.color}"
                            >{{ t.text }}</b-radio>
                        </b-field>
                        <h3>Choose permission group (who will be able to see this announcement)</h3>
                        <b-field grouped group-multiline>
                            <b-field><b-checkbox @input="toggleAllPermissions" class="checkbox-perm" v-model="hasAllPermissions">All</b-checkbox></b-field>
                            <b-field v-for="(g, index) in groups" :key="index">
                                <b-checkbox :native-value="g.id"
                                            v-model="permissions"
                                            >{{ g.group_name }}</b-checkbox>
                            </b-field>
                        </b-field>
                        <button class="uk-button uk-button-primary"
                                :disabled="!announcementValidator"
                                type="button"
                                @click="addAnnouncement(index)">Add
                        </button>
                        <button class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button>
                    </div>
                </div>
            </div>

            <div id="add-widget-modal" uk-modal>
                <div class="uk-modal-dialog uk-modal-body">
                    <b-field label="Select Grid Size">
                        <b-select v-model="addExternal.grid_size">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                        </b-select>
                    </b-field>
                    <div class="title-container">
                        <b-field label="Title"
                                 :type="validator(addExternal.title, 'text', 'external')"
                        >
                            <b-input v-model="addExternal.title"></b-input>
                        </b-field>
                    </div>
                    <div class="message-container">

                        <b-field label="Message"
                            :type="validator(addExternal.message, 'text', 'external')">
                            <b-input type="textarea" v-model="addExternal.message"></b-input>
                        </b-field>
                    </div>
                    <b-field
                        label="Content Type">
                        <b-select v-model="externalType">
                            <option value="simple">Link to a different page</option>
                            <option value="modal">Pop-up with multiple links</option>
                            <option value="pdf">Downloadable PDF</option>
                            <option value="user-upload">User File Upload</option>
                        </b-select>
                    </b-field>
                    <div class="link-container" v-if="externalType == 'simple'">
                        <b-field label="Link"
                                 :type="validator(addExternal.url_link, 'link', 'external')"
                        >
                            <b-input v-model="addExternal.url_link"></b-input>
                        </b-field>
                    </div>
                    <div class="modal-links" v-if="externalType === 'modal'">

                        <div class="add-links">
                            <b-field label="Text"
                                     :type="validator(modal_link.text, 'text', 'external')"
                            >
                                <b-input v-model="modal_link.text"></b-input>
                            </b-field>
                            <b-field label="Link Text"
                                     :type="validator(modal_link.link_text, 'text', 'external')"
                            >
                                <b-input v-model="modal_link.link_text"></b-input>
                            </b-field>
                            <b-field>
                                <b-radio-button v-model="modal_link.is_file" :native-value="false">External Link</b-radio-button>
                                <b-radio-button v-model="modal_link.is_file" :native-value="true">File Link</b-radio-button>
                            </b-field>
                            <b-field
                                :type="validator(modal_link.link, 'link', 'external')"
                                v-if="!modal_link.is_file" label="URL Link">
                                <b-input v-model="modal_link.link"></b-input>
                            </b-field>
                            <div v-else>
                                <b-field>
                                    <b-upload v-model="modal_link.file"
                                              drag-drop
                                              label="upload-file">
                                        <section class="section">
                                            <div class="content has-text-centered">
                                                <p><b-icon icon="upload" size="is-large"></b-icon></p>
                                                <p>Drop your file here or click to upload a file</p>
                                            </div>
                                        </section>
                                    </b-upload>
                                </b-field>
                                <div class="tags">
                                    <span class="tag" :class="validator(modal_link.file, 'file', 'external')" v-if="modal_link.file">
                                        {{ modal_link.file.name }}
                                        <button class="delete is-small" @click="modal_link.file = null"></button>
                                    </span>
                                </div>
                            </div>
                            <b-button v-if="editToggle" @click="addLinkToModal(modal_link)" :disabled="!externalValidator" class="btn-primary">Add Link</b-button>
                            <b-button v-else @click="addLinkToModalPlaceholder" :disabled="!externalValidator" class="btn-primary">Add Link</b-button>
                        </div>
                        <table v-if="editToggle" class="uk-table link-list-table">
                            <tbody>
                                <tr v-for="(link, index) in listModalLink" :key="index">
                                    <td>{{ link.url_text }} - {{ link.text }}</td>
                                    <td><b-button class="uk-button-danger uk-button-small" @click="removeLinkFromList(link)">Remove</b-button></td>
                                </tr>
                            </tbody>
                        </table>
                        <table v-else class="uk-table link-list-table">
                            <tbody>
                                <tr v-for="(link, index) in linksToSave" :key="index">
                                    <td>{{ link.link_text }} - {{ link.text }}</td>
                                    <td><b-button class="uk-button-danger uk-button-small" @click="linksToSave.splice(index, 1)">Remove</b-button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="" v-if="externalType == 'pdf' || externalType == 'user-upload'">
                        <p v-if="externalType === 'user-upload'">Upload a file here if you wish for the user to download.  Users can download the file, fill it out, and drop a new file.</p>
                        <b-field>
                            <b-upload v-model="addExternal.download_file"
                                      drag-drop
                                      label="upload-file">
                                <section class="section">
                                    <div class="content has-text-centered">
                                        <p><b-icon icon="upload" size="is-large"></b-icon></p>
                                        <p>Drop your file here or click to upload a file</p>
                                    </div>
                                </section>

                            </b-upload>
                            <div class="tags">
                                <span class="tag" :class="validator(addExternal.download_file, 'file', 'external')" v-if="addExternal.download_file">
                                    {{ addExternal.download_file.name }}
                                    <button class="delete is-small" @click="addExternal.download_file = null"></button>
                                </span>
                            </div>
                        </b-field>
                    </div>
                    <div v-if="editToggle && (externalType === 'pdf' || externalType === 'user-upload')">
                        Current: <b-tag type="is-primary">{{ addExternal.current_file_name }}</b-tag>
                    </div>
                    <br>
                    <p><b>{{ addExternal.image ? 'Replace Current Image' : 'Do you want to upload an image?'}}</b></p>

                    <br>
                    <b-field v-if="!editToggle">
                        <b-radio v-model="uploadImage"
                            :native-value="true">Yes</b-radio>
                        <b-radio v-model="uploadImage"
                                        :native-value="false">No</b-radio>
                    </b-field>
                    <b-field v-else>
                        <b-radio v-model="replaceImage"
                            :native-value="true">Yes</b-radio>
                        <b-radio v-model="replaceImage"
                                        :native-value="false">No</b-radio>
                    </b-field>
                    <div v-if="addExternal.image">
                        <p>Current image</p>
                        <img :src="addExternal.image" style="width: 100%; max-width: 300px" alt="image for widget" />
                    </div>
                    <div class="image-container" v-if="uploadImage || replaceImage">
                        <b-field>
                            <b-upload v-model="addExternal.imageFile"
                                      multiple
                                      drag-drop
                                      label="upload-image">
                                <section class="section">
                                    <div class="content has-text-centered">
                                        <p>
                                            <b-icon
                                                icon="upload"
                                                size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Drop your files here or click to upload an image</p>
                                    </div>
                                </section>
                            </b-upload>
                        </b-field>
                    </div>

                    <div class="tags">
                        <span v-for="(file, index) in addExternal.imageFile"
                              :key="index"
                              class="tag is-primary">
                            {{file.name}}
                            <button class="delete is-small"
                                    type="button"
                                    @click="deleteDropFile(index)">
                            </button>
                        </span>
                    </div>
                    <p><b>Permissions</b></p><br>
                    <div class="permissions-checkbox-group block columns">
                        <b-checkbox @input="toggleAllPermissions" class="checkbox-perm" v-model="hasAllPermissions">All</b-checkbox>
                        <b-checkbox
                            class="checkbox-perm"
                            v-for="(g, index) in groups"
                            v-model="permissions"
                            :key="index"
                            :native-value="g.id">
                                {{ g.group_name }}
                        </b-checkbox>
                    </div>
                    <button class="uk-button uk-button-primary" type="button"
                            :disabled="!externalValidator"
                            @click="editToggle ? editWidget() : addWidget()">{{editToggle ? 'Update' : 'Add'}}
                    </button>
                    <button class="uk-button uk-button-default uk-modal-close" @click="editToggle = false" type="button">Cancel</button>

                </div>

            </div>
        </div>
        <div></div>
    </div>

</template>

<script>
    import {Drag, Drop} from 'vue-drag-drop'
    import moment from 'moment'
    import draggable from 'vuedraggable'
    import UIkit from 'uikit';
    import api from "../../store/apicall";

    export default {
        props: ['all_widgets', 'history', 'groups'],
        name: "WidgetsEdit",
        components: {
            Drag,
            Drop,
            draggable
        },
        data() {
            return {
                addContentTo: null,
                addContentId: null,
                announcementContent: {
                    title: '',
                    message: '',
                    type: 'default',
                    url_link: null,
                    file: null,
                    start_date: null,
                    end_date: null
                },
                announcementValidator: true,
                addAnnouncementTo: null,
                announcements: [],
                external: [],
                internal: [],
                showAnnouncementList: true,
                editAnnouncement: null,
                changeA: null,
                announcementTypeList: [
                    // {text: '', value: 'default', color: '#4a4a4a'},
                    {text: 'Total Satisfaction', value: 'success', color: '#23d160'},
                    {text: 'CSN Program Updates', value: 'info', color: '#167df0'},
                    {text: 'Service Alerts', value: 'danger', color: '#ff3860'},
                    // {text: 'Service Alerts', value: 'warning', color: '#ffdd57'}
                ],
                isAnnouncementLink: true,
                editToggle: false,
                addExternal: {
                    type: 'external',
                    order: 0,
                    grid_size: 1,
                    title: '',
                    message: '',
                    image: null,
                    imageFile: null,
                    permissions: null,
                    url_link: '',
                    download_file: null,
                    modal_content: null
                },
                externalValidator: true,
                externalType: 'simple',
                uploadImage: false,
                replaceImage: false,
                modal_link: {
                    link: null,
                    link_text: null,
                    text: null,
                    is_file: false,
                    file: null
                },
                hasAllPermissions: true,
                permissions: [], // move this to add External
                allPermissions: [],
                linksToSave: [],
                rearrangingAnnouncements: false,
                newOrderAnnouncements: [],
                creatingNewWidget: false,
                editingWidgetId: null
            }
        },
        methods: {
            filterWidgets() {
                let widgets = this.all_widgets
                console.log('all the widgets', widgets);
                let announcements = widgets.filter(w => {
                    if (w.widget.type == 'announcement') return w
                })
                let external = widgets.filter(w => {
                    if (w.widget.type == 'external') {
                        if (w.type === 'modal' && w.modal_content.length > 0) {
                            w.modal_content = w.modal_content.sort((a, b) => {
                                if (a.id > b.id) return -1
                                if (a.id < b.id) return 1
                                return 0
                            })
                        }
                        return w
                    }
                })
                let internal = widgets.filter(w => {
                    if (w.widget.type == 'internal') return w
                })
                console.log('the announcements before sort', announcements);
                announcements = announcements.sort((a, b) => {
                    if (a.order > b.order) {
                        return 1
                    } else if (a.order < b.order) {
                        return -1
                    } else {
                        return 0
                    }
                })
                this.announcements = announcements.map(a => {
                    let announcement = {...a}
                    //announcement.isActive = true
                    return announcement
                })
                this.external = external.sort((a, b) => {
                    if (a.order > b.order) {
                        return 1
                    } else if (a.order < b.order) {
                        return -1
                    } else {
                        return 0
                    }
                })

                this.internal = internal.sort((a, b) => {
                    if (a.order > b.order) {
                        return 1
                    } else if (a.order < b.order) {
                        return -1
                    } else {
                        return 0
                    }
                })
            },
            addAnnouncement(index, id) {

                const _t = this;

                let request = {
                    purpose: 'add_widget',
                    parameters: {
                        grid_size: 1,
                        order: _t.announcements.length,
                        type: 'announcement',
                        title: _t.announcementContent.title,
                        message: _t.announcementContent.message,
                        announcementType: _t.announcementContent.type,
                        permissions: _t.permissions,
                        time: null,
                        image: null,
                        url_link:_t.isAnnouncementLink ?  _t.announcementContent.url_link : null,
                        modal_content: null,
                        start_date: _t.announcementContent.start_date,
                        end_date: _t.announcementContent.end_date
                    }
                }


                api.post('/homepage/', request).then(function (response) {
                    console.log('response', response);
                    if (!_t.isAnnouncementLink) {
                            console.log('we have a downloadable file')
                            let formData = new FormData();
                            let file = _t.announcementContent.file
                            formData.append('file', file);
                            formData.append('id', response.data.id)
                            console.log(formData)
                            api.post('/homepage/file-upload/', formData)
                                .then(fileResponse => {
                                    _t.$emit('addingWidget', fileResponse.data)
                                    // if (_t.uploadImage){
                                    //     _t.addImageToWidget(fileResponse.data)
                                    // } else {
                                    //
                                    //     _t.resetExternalAdd()
                                    // }
                                })
                        } else {
                            _t.announcements.push({
                                grid_size: response.data.grid_size,
                                order: response.data.order,
                                type: response.data.widget.type,
                                id: response.data.id,
                                title: response.data.title,
                                message: response.data.message,
                                announcementType: response.data.announcementType,
                                permissions: response.data.empoloyee_groups
                            })
                    }


                }).catch((err) => {
                    console.log(`add widget${err}`)
                })


                UIkit.modal('#add-announcement-modal').hide();
            },
            addWidgetContent(index, id) {
                this.addContentTo = index
                this.addContentId = id;
                this.addContent = {
                    type: 'Choose content type',
                    message: '',
                    image: null,
                    imageFile: null,
                    order: null,
                    permissions: null,
                    link_text: '',
                    link_url: ''
                }
            },

            clearAddWidget() {
                if (!this.creatingNewWidget) {
                    this.editToggle = false
                    this.externalType = 'simple'
                    this.addContentId = null
                    this.resetExternalAdd()
                    this.creatingNewWidget = true
                }
            },

            addWidget() {
                const _t = this;
                const request = {
                    purpose: 'add_widget',
                    parameters: {
                        grid_size: _t.addExternal.grid_size,
                        order: _t.external.length,
                        type: 'external',
                        title: _t.addExternal.title,
                        message: _t.addExternal.message,
                        image: _t.addExternal.image,
                        imageFile: _t.addExternal.imageFile,
                        permissions: _t.permissions,
                        url_link: _t.addExternal.url_link,
                        time: this.formattedTime,
                        announcementType: null,
                        externalType: _t.externalType,
                    }
                }

                api.post('/homepage/', request)
                    .then(function (response) {
                        console.log('response', response);
                        let res = response.data
                        if (_t.addExternal.download_file != null) {
                            console.log('we have a downloadable file')
                            let formData = new FormData();
                            let file = _t.addExternal.download_file
                            formData.append('file', file);
                            formData.append('id', response.data.id)
                            console.log(formData)
                            api.post('/homepage/file-upload/', formData)
                                .then(fileResponse => {
                                    if (_t.uploadImage){
                                        _t.addImageToWidget(fileResponse.data)
                                    } else {
                                        _t.$emit('addingWidget', fileResponse.data)
                                        _t.resetExternalAdd()
                                    }
                                })
                        } else {
                            if (_t.externalType === 'modal') {
                                _t.$emit('addingWidget', res)
                                _t.addContentId = res.id
                                _t.linksToSave.forEach(l => {
                                    console.log('saving link', l, _t.addContentId)
                                    _t.addLinkToModal(l)
                                })
                            }
                            if (_t.uploadImage) {
                                _t.addImageToWidget(res)
                            } else {
                                if (_t.externalType !== 'modal') {
                                    _t.$emit('addingWidget', res)
                                }
                                _t.resetExternalAdd()
                            }
                        }
                    }).catch((err) => {
                        console.log(`add widget${err}`)
                    })
                _t.creatingNewWidget = false
                UIkit.modal('#add-widget-modal').hide();


            },

            addImageToWidget(data) {
                console.log('we have an image file')
                let _t = this
                let formData = new FormData();
                let file = _t.addExternal.imageFile[0];
                formData.append('image', file);
                formData.append('id', data.id);
                api.post('/homepage/carousel-upload/', formData).then(function (imageResponse) {
                    console.log('carousel picture response', imageResponse);
                    _t.$emit('addingWidget', imageResponse.data)
                    _t.resetExternalAdd()
                }).catch((err) => {
                    console.log(err)
                })
            },
            replaceImageToWidget() {
                console.log('replacing image')
                let _t = this
                let formData = new FormData()
                let file = _t.addExternal.imageFile[0]
                formData.append('image', file)
                formData.append('id', _t.addContentId)
                api.post('/homepage/carousel-upload/', formData)
                    .then(res => {
                        let data = res.data
                        _t.external[_t.addContentIndex].image = data.image
                        _t.$emit('edited')
                        _t.resetExternalAdd()
                    })
            },
            editWidgetToggle(id, index) {
                this.creatingNewWidget = false
                if (this.editingWidgetId != id) {
                    console.log('edit toggle', id, index)
                    this.editingWidgetId = id
                    this.editToggle = true;
                    this.addContentId = id
                    this.addContentIndex = index
                    this.uploadImage = false
                    this.addExternal.grid_size = this.external[index].grid_size
                    this.addExternal.title = this.external[index].title
                    this.addExternal.message = this.external[index].message
                    this.permissions = this.external[index].employee_groups

                    this.externalType = this.external[index].type
                    if (this.external[index].type == 'simple') {
                        console.log('edit simple')
                        this.addExternal.url_link = this.external[index].url_link
                    }
                    if (this.external[index].type == 'modal') {

                        this.addExternal.modal_content = this.external[index].modal_content
                    }
                    if (this.external[index].type == 'pdf') {
                        console.log('edit pdf')
                        this.addExternal.download_file = null
                        this.addExternal.current_file_name = this.external[index].file.replace('https://wageup-media.s3.amazonaws.com/', '')
                    }
                    if (this.external[index].image != null) {
                        // this.uploadImage = true
                        this.addExternal.image = this.external[index].image
                    }
                }
            },

            editWidget() {
                const _t = this;


                const request = {
                    purpose: 'edit_widget',
                    parameters: {
                        widget_id: _t.addContentId,
                        grid_size: _t.addExternal.grid_size,
                        title: _t.addExternal.title,
                        message: _t.addExternal.message,
                        url_link: _t.addExternal.url_link,
                        time: _t.formattedTime,
                        modal_content: _t.addExternal.modal_content,
                        permissions: _t.permissions
                    }
                }

                api.post('/homepage/', request).then(function (response) {
                    console.log('edit response', response);
                    _t.external[_t.addContentIndex] = {
                        grid_size: response.data.grid_size,
                        title: response.data.title,
                        message: response.data.message,
                        url_link: response.data.url_link,
                        time: response.data.time,
                        image: response.data.image
                    }
                    console.log('external after request', _t.external)
                    if (_t.addExternal.download_file != null) {
                        console.log('this edit is to update the file')
                        let formData = new FormData()
                        let widget_id = _t.addContentId
                        formData.append('file', _t.addExternal.download_file)
                        formData.append('id', widget_id)
                        api.post('/homepage/file-upload/', formData)
                            .then(responseFile => {
                                let resData = responseFile.data
                                _t.external[_t.addContentIndex].file = resData.file
                                if (_t.addExternal.imageFile != null) {
                                    _t.replaceImageToWidget()
                                } else {
                                    _t.$emit('edited')
                                    _t.resetExternalAdd()
                                }
                            })
                    } else {
                        if (_t.addExternal.imageFile != null) {
                            _t.replaceImageToWidget()
                        } else {
                            _t.$emit('edited')
                            _t.resetExternalAdd()
                        }
                    }
                    // _t.$emit('edited')
                    // _t.editToggle = false

                }).catch(err => {
                    console.log(`edit error ${err}`)
                })


                UIkit.modal('#add-widget-modal').hide();
            },
            editAnnouncementSetup(announcement) {
                console.log('editing announcement', announcement)
                this.editAnnouncement = announcement.id
                this.changeA = announcement
                this.changeA.start_date = new Date(moment.utc(announcement.start_date).format('YYYY-MM-DD'))
                this.changeA.end_date = new Date(moment.utc(announcement.end_date).format('YYYY-MM-DD'))
                this.permissions = announcement.employee_groups
            },
            submitAnnouncementEdit(index) {
                let widget = this.announcements[index];
                this.changeA.employee_groups = this.permissions
                let _t = this;
                let request = {
                    purpose: 'edit_announcement',
                    parameters: {
                        'widget_id': widget.id,
                        'edit': _t.changeA
                    }
                }
                api.post('/homepage/', request)
                    .then(res =>  {
                        _t.$emit('edited')
                        _t.cancelEditAnnouncement()
                    })
            },
            cancelEditAnnouncement() {
                this.editAnnouncement = null;
                this.changeA = null;
            },
            deleteWidgetConfirm(id, index) {
                let _t = this
                _t.$buefy.dialog.confirm({
                    message: 'Are you sure you want to permanently remove this?',
                    type: 'is-danger',
                    hasIcon: true,
                    confirmText: 'Yes, Delete',
                    onConfirm() {
                        _t.deleteWidget(id, index)
                    },
                    cancelText: 'No, Keep'
                })
            },
            deleteWidget(id, index) {
                const request = {
                    purpose: 'delete_widget',
                    parameters: {
                        widget_id: id

                    }

                }
                let _t = this
                console.log('delete widget request', request)
                api.post('/homepage/', request).then((response) => {
                    console.log('delete response', response);
                    _t.$emit('deleteWidget', id)
                    // _t.external.splice(index, 1)
                }).catch((err) => {
                    console.log(`delete widget${err}`)
                })



            },

            deleteAnnouncementConfirm(id, contentId, index) {
                let _t = this
                UIkit.modal('#add-announcement-modal').hide();
                _t.$buefy.dialog.confirm({
                    message: 'Are you sure you want to permanently delete this announcement?',
                    type: 'is-danger',
                    hasIcon: true,
                    confirmText: 'Yes, delete announcement',
                    cancelText: 'No, keep announcement',
                    onConfirm() {
                        _t.deleteAnnouncement(id, contentId, index)
                    }
                })
            },
            //Need to refactor this into one method
            deleteAnnouncement(id, contentId, index) {
                console.log('deleting announcement');
                const request = {
                    purpose: 'delete_widget',
                    parameters: {
                        widget_id: id

                    }

                }
                console.log('content id', id, contentId)
                console.log('delete widget request', request)
                api.post('/homepage/', request).then(function (response) {
                    console.log('delete response', response);
                }).catch((err) => {
                    console.log(`delete widget${err}`)
                })
                // try {
                //     const contentRequest = {
                //         purpose: 'delete_content',
                //         parameters: {
                //             content_id: contentId
                //
                //         }
                //     }
                //
                //     console.log('delete content request', contentRequest)
                //     api.post('/homepage/', contentRequest).then(function (response) {
                //         console.log('delete content response', response);
                //     }).catch((err) => {
                //         console.log(`delete content error ${err}`)
                //     })
                // } catch(e) {
                //     console.log(e)
                // }
                this.$emit('deleteWidget', id)



            },
            deleteContent(id, widgetIndex, contentIndex) {
                console.log('delete content id', id)
                const request = {
                    purpose: 'delete_content',
                    parameters: {
                        content_id: id

                    }
                }

                console.log('delete content request', request)
                api.post('/homepage/', request).then(function (response) {
                    console.log('delete content response', response);
                }).catch((err) => {
                    console.log(`delete content error ${err}`)
                })
                this.external[widgetIndex].content.splice(contentIndex, 1)
            },
            externalClass(size) {

                if (size == 1) {
                    return `is-one-fifth`
                } else if (size == 2) {
                    return `is-two-fifths`
                } else if (size == 3) {
                    return `is-three-fifths`
                } else if (size == 4) {
                    return `is-full`
                }

            },
            addLinkToModal(link) {
                let _t = this;
                console.log('add link to', _t.addContentId)
                if (_t.addExternal.modal_content || _t.linksToSave.length > 0) {
                    if (link.is_file) {
                        let formData = new FormData()
                        formData.append('file', link.file)
                        formData.append('widget_id', _t.addContentId)
                        formData.append('text', link.text)
                        formData.append('url_text', link.link_text)
                        api.post('/homepage/modal-file-upload/', formData)
                            .then(res => {
                                console.log('modal content', res.data)
                                _t.$emit('added_link_modal', {widget_id: _t.addContentId, data: res.data})
                                if (_t.editToggle){
                                    console.log('modal content', res.data)
                                    if (!_t.addExternal.includes(res.data))
                                        _t.addExternal.modal_content.unshift(res.data)
                                    _t.modal_link = {
                                        link: null,
                                        link_text: null,
                                        text: null,
                                        is_file: false,
                                        file: null
                                    }
                                }
                            })
                    } else {
                        let request = {
                            'purpose': 'add_content',
                            'parameters': {
                                'widget_id': _t.addContentId,
                                'is_file': link.is_file,
                                'text': link.text,
                                'url_text': link.link_text,
                                'url_link': link.link
                            }
                        }
                        api.post('/homepage/', request)
                            .then(res => {
                                let data = res.data
                                _t.$emit('added_link_modal', {widget_id: _t.addContentId, data: data})
                                if (_t.editToggle) {
                                    if (!_t.addExternal.modal_content.includes(res.data))
                                        _t.addExternal.modal_content.unshift(res.data)
                                    // _t.addExternal.modal_content.unshift(data)
                                    _t.modal_link = {
                                        link: null,
                                        link_text: null,
                                        text: null,
                                        is_file: false,
                                        file: null
                                    }
                                }
                            })
                    }


                    // let new_link = `<a href="${_t.modal_link.link}" target="_blank">${_t.modal_link.link_text}</a> - ${_t.modal_link.text}`
                    // if (_t.addExternal.modal_content.html_text.length != 0) {
                    //     _t.addExternal.modal_content.html_text = `${new_link}<br>${_t.addExternal.modal_content.html_text}`
                    // } else {
                    //     _t.addExternal.modal_content.html_text = new_link
                    // }
                    // _t.modal_link = {
                    //     link: null,
                    //     link_text: null,
                    //     text: null
                    // }
                }
            },
            resetExternalAdd() {
                this.addExternal = {
                    type: 'external',
                    order: 0,
                    grid_size: 1,
                    title: '',
                    message: '',
                    image: null,
                    imageFile: null,
                    permissions: null,
                    url_link: '',
                    download_file: null,
                    modal_content: null
                }
            },
            // setCarousel(w_list) {
            //     console.log('set carousel fired')
            //     if (w_list.length === 0) {
            //         return;
            //     }
            //     console.log('w list', w_list);
            //     let images = w_list.filter(w => {
            //         if (w.type == 'Image' || w.type == 'image') return w
            //     })
            //     console.log('images before map', images)
            //
            //     let carousel = images.map(i => {
            //         return {
            //             img: i.image,
            //             order: i.order,
            //             text: i.message
            //         }
            //     })
            //
            //     console.log('carousel before sort', carousel)
            //     return carousel.sort((a, b) => {
            //         if (a.order > b.order) {
            //             return 1
            //         } else if (a.order < b.order) {
            //             return -1
            //         } else {
            //             return 0
            //         }
            //     })
            //
            // },
            widgetContent(w_list) {

                if (w_list.length === 0) {
                    return;
                }

                let content = w_list.filter(w => {

                    if (w.type != 'image') {

                        return w
                    }
                })

                return content.sort((a, b) => {
                    if (a.order > b.order) {
                        return 1
                    } else if (a.order < b.order) {
                        return -1
                    } else {
                        return 0
                    }
                })
            },
            changeOrder() {
                this.external.map((e, i) => {
                    e.order = i
                })

                const request = {
                    purpose: 'widget_move',
                    parameters: {
                        widget_list: this.external
                    }
                }

                api.post('/homepage/', request).then((response => {

                    console.log(response)

                })).catch(err => {
                    console.log(`move error ${err}`)
                })
            },
            removeLinkFromList(link) {
                let link_id = link.id
                let request = {
                    'purpose': 'delete_content',
                    'parameters': {
                        'content_id': link_id
                    }
                }
                let _t = this
                api.post('/homepage/', request)
                    .then(res => {
                        _t.$emit('removeModalLink', {widget_id: _t.addContentId, link: link})
                        _t.addExternal.modal_content.forEach((l, index, arr) => {
                            if (l.id === link_id) {
                                arr.splice(index, 1)
                            }
                        })
                    })
            },
            validator(val, type, effect) {
                console.log('validator', val, type)
                if (val === null){
                    return ''
                }
                if (type === 'link') {
                    if ((val.startsWith('https://') || val.startsWith('http://'))) {
                        // return true
                        return 'is-success'
                    } else {
                        // if (effect == 'announcement' && this.announcementValidator) this.announcementValidator = false
                        // if (effect == 'external' && this.externalValidator) this.externalValidator = false
                        return 'is-danger'
                        // return false
                    }
                }
                if (type === 'text') {
                    if (val.length > 2) {
                        // if (effect == 'announcement' && !this.announcementValidator) this.announcementValidator = true
                        // if (effect == 'external' && !this.externalValidator) this.externalValidator = true
                        // return true
                        return 'is-success'

                    } else {
                        // if (effect == 'announcement' && this.announcementValidator) this.announcementValidator = false
                        // if (effect == 'external' && this.externalValidator) this.externalValidator = false
                        return 'is-danger'
                        // return false

                    }
                }
                if (type === 'file') {
                    if (this.editToggle) {

                    } else {
                        let allowExt = ['pdf', 'csv', 'docx', 'doc', 'xls', 'xlsx']
                        let ext = val.name.split('.').reverse()[0]
                        if (allowExt.includes(ext)) {
                            // if (effect == 'announcement' && !this.announcementValidator) this.announcementValidator = true
                            // if (effect == 'external' && !this.externalValidator) this.externalValidator = true
                            // return true
                            return 'is-success'
                        } else {
                            // if (effect == 'announcement' && this.announcementValidator) this.announcementValidator = false
                            // if (effect == 'external' && this.externalValidator) this.externalValidator = false
                            return 'is-danger'
                            // return false
                        }
                    }
                }
            },
            toggleAllPermissions() {
                console.log("toggle all permissions", this.hasAllPermissions)
                if (this.hasAllPermissions) {
                    this.permissions = this.groups.map(g => {return g.id})
                } else {
                    this.permissions = []
                }
            },
            startDrag() {
                this.drag = this.hasPermissionToEdit
            },
            addLinkToModalPlaceholder() {
                this.linksToSave.push(this.modal_link)
                this.modal_link = {
                    link: null,
                    link_text: null,
                    text: null,
                    is_file: false,
                    file: null
                }
            },
            saveAnnouncementOrder() {
                let newOrderA = this.newOrderAnnouncements.map((a, index) => {
                    return {id: a.id, order: index}
                })
                let request = {
                    'purpose': 're_order_announcements',
                    'parameters': {
                        'announcements': newOrderA
                    }
                }
                let _t = this
                api.post('/homepage/', request)
                    .then(res => {
                        _t.$emit('updateAnnouncement', res.data)
                        _t.rearrangingAnnouncements = false
                        _t.$buefy.snackbar.open({
                            type: 'is-success',
                            message: 'Order Saved!'
                        })
                    })
            }
        },

        computed: {

            formattedTime: function () {
                return moment().format('MMM Do YYYY - h:mm A')
            },
            listModalLink: function() {
                if (this.addExternal.modal_content) {
                    if (this.addExternal.modal_content.length > 0) {
                        return this.addExternal.modal_content
                    }
                    return []
                } else {
                    return []
                }
            },
            hasPermissionToEdit() {
                let permissions = this.$store.state.user.data.permission
                let permission_ids = permissions.map(p => {
                    return p.id
                })
                return (permission_ids.includes(10) || permission_ids.includes(28))
            }
        },

        watch: {
            all_widgets: function () {
                this.filterWidgets();
            },
            external: function () {
                this.changeOrder();
            },
            showAnnouncementList: function() {
                this.announcementContent = {
                    title: '',
                    message: '',
                    type: 'default',
                    url_link: null,
                    file: null,
                    start_date: null,
                    end_date: null
                }
            },
            permissions(value) {
                console.log(value)
                let all_groups = this.groups.map(g => {return g.id})
                let itHasAll = true
                for (let g in all_groups) {
                    if (!value.includes(all_groups[g])) {
                        itHasAll = false
                    }
                }
                this.hasAllPermissions = itHasAll
            },
            rearrangingAnnouncements() {
                this.newOrderAnnouncements = this.announcements.map(a => {return a})
            }
            // hasAllPermissions: function(value) {
            //     console.log('all permissions value', value)
            //     if (value) {
            //         this.permissions = this.groups.map(g => {return g.id})
            //     } else {
            //         this.permissions = []
            //     }
            // }
        },

        filters: {
            dateFormat(date) {
                let format = moment(date).format('MM/DD/YYYY h:mmA')
                return format
            }
        },

        mounted() {
            this.filterWidgets();
            this.permissions = this.groups.map(g => {return g.id})
        }
    }
</script>

<style lang="less" scoped>


    #widgets {

    }

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px grey;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background: #2d5795;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: rgb(54, 56, 58);
    }

    .top {
        margin-top: 10px;
    }

    #announcements, #history {
        height: auto;
        margin-left: 2%;
        border-radius: 25px;
        padding: 25px;
        .announcement-widget-container, .history-widget-container {
            overflow: scroll;
            overflow-x: hidden;
            max-height: 40vh;
        }
    }

    #internal {
        min-height: 35vh;
        padding-top: 25px;
    }

    #history {
        margin-left: 0;
        margin-right: 2%;
        text-align: left;
    }


    .announcement-container {
        margin-left: 5%;
        margin-right: 5%;
        margin-top: 20px;
        margin-bottom: 20px;
    }


    #internal {
        height: 40vh;

    }

    .internal-widget-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
    }

    .image-icon {
        width:30%;
    }


    .card-icon {
        margin-top: 15%;
    }

    .card-title {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }

    .title {
        font-size: 1.5em;

    }

    .content {
       margin-top: 5%;
    }

    #external {
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 2%;
    }

    .external-widget-container {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
    }


    h2 {
        text-align: center;
        font-size: 2em;
        margin-bottom: 10px;
    }


    .add-widget {
        margin-bottom: 2%;
        margin-top: 2%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        border-radius: 0px;
        min-height: 450px;
    }

    .add-new-widget-button {
        width: auto;
    }

    .widget {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-right: 2%;
        margin-bottom: 2%;
        margin-top: 2%;

    }

    .card-content {
        text-align: left;
    }

    .card-image {

    }

    .external-image {
        max-height: 350px;
    }

    .column {
        padding: 0;
    }

    .homepage-card {
        cursor: move;
    }

@media only screen and (max-width: 1720px) {
        .title {
            font-size: 1.25em;
        }
    }

    @media only screen and (max-width: 1600px) {
        .card-title {
            flex-direction: column;
        }
        .image-icon {
            width: 50%;
        }
    }

    @media only screen and (max-width: 1200px) {
        .card-title {
            flex-direction: column;
        }
        .announcement-container {
            margin-left: 2.5%;
        margin-right: 2.5%;

        }
        .title {
            font-size: 1em;
        }
    }

     @media only screen and (max-width: 1025px) {

        .title {
            font-size: 2em;
        }
    }

    @media only screen and (max-width: 900px) {
        .internal-widget-container{
          flex-wrap: wrap;
        }
    }

    @media only screen and (max-width: 770px) {
        .widget{
            margin-left:5%;
            width: 90% !important;
        }


        /*.card {*/
        /*    width: 90% !important;*/
        /*}*/

        .card-title {
            flex-direction: row;
        }
        .title {
            font-size: 2em;
        }
        .image-icon {
            width: 20%;
        }
    }

    .link-list-table {
        max-height: 200px;
        overflow-y: scroll;
        width: 100%;
    }
    .permissions-checkbox-group {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        .checkbox-perm {
            margin: 5px 0;
            padding: 0;
            width: 33%;
            text-align: left;
        }
    }
     /*{text: 'Default', value: 'default', color: '#4a4a4a'},*/
     /*               {text: 'Success', value: 'success', color: '#23d160'},*/
     /*               {text: 'Info', value: 'info', color: '#167df0'},*/
     /*               {text: 'Danger', value: 'danger', color: '#ff3860'},*/
     /*               {text: 'Warning', value: 'warning', color: '#ffdd57'}*/
    .border-default {
        border-left: solid 3px #4a4a4a;
        padding-left: 3px;
    }
    .border-success {
        border-left: solid 3px #23d160;
        padding-left: 3px;
    }
    .border-info {
        border-left: solid 3px #167df0;
        padding-left: 3px;
    }
    .border-danger {
        border-left: solid 3px #ff3860;
        padding-left: 3px;
    }
    .border-warning {
        border-left: solid 3px #ffdd57;
    }
    .reorder-announcement {
        cursor: s-resize;
        padding: 20px 10px;
        text-align: left;
        /*border-left: solid #333 thin;*/
    }
</style>
